module.exports = "<app-searchfilters-archived-document></app-searchfilters-archived-document> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/home/archiveddocument/partial.html
// module id = 411
// module chunks = 0